// src/api/fiadosApi.js
//
// Fiados: crédito informal con confirmación bilateral (veci + negocio).

import { api } from './apiClient';

export const fiados = {
  crear: (payload) => api.post('/api/holaveci/fiados', payload),

  /** Filtro por estado opcional: VIGENTE | PAGADO | CANCELADO. */
  listar: (estado) => api.get('/api/holaveci/fiados', { query: { estado } }),

  detalle: (fiadoId) => api.get(`/api/holaveci/fiados/${fiadoId}`),

  /** El veci confirma que el fiado que el negocio le anotó es correcto. */
  confirmar: (fiadoId) => api.post(`/api/holaveci/fiados/${fiadoId}/confirmar`, {}),

  /** El veci reclama que ese fiado no le corresponde. */
  reclamar: (fiadoId, motivo) =>
    api.post(`/api/holaveci/fiados/${fiadoId}/reclamar`, { motivo }),

  /** El negocio registra un abono. */
  registrarAbono: (fiadoId, payload) =>
    api.post(`/api/holaveci/fiados/${fiadoId}/abonos`, payload),

  anular: (fiadoId, motivo) =>
    api.post(`/api/holaveci/fiados/${fiadoId}/anular`, { motivo }),
};
